import React from "react";
import Helmet from "react-helmet";

import "../styles/contact.scss";
import Column from "../components/column";

const getEmail = email => `mailto:${email}`;
const ContactItem = ({ item }) => {
  return (
    <div className={"contact-item"}>
      <h2 className={"contact-item__headline"}>{item.section}</h2>
      {item.sections.map(section => {
        return (
          <div className={"contact-item__section"} key={section.email}>
            {section.region && (
              <span className={"contact-item__region"}>{section.region}</span>
            )}
            <span className={"contact-item__name"}>{section.name}: </span>
            <a
              href={`mailto:${section.email}`}
              className={"contact-item__email"}
            >
              {section.email}
            </a>
          </div>
        );
      })}
    </div>
  );
};

const ContactPage = ({ data }) => {
  const items = data.allContactsJson.edges;
  return (
    <div className={"contact"}>
      <Helmet title="Contact | Thomas Carty" />
      <div className={"contact__items"}>
        {items.map(section => (
          <ContactItem item={section.node} key={section.node.identifier} />
        ))}
      </div>
    </div>
  );
};

export const pageQuery = graphql`
  query ContactPageQuery {
    allContactsJson {
      edges {
        node {
          section
          identifier
          sections {
            region
            name
            email
          }
        }
      }
    }
  }
`;
export default ContactPage;



// WEBPACK FOOTER //
// ./src/pages/contact.js